'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

let _ = t => t,
    _t,
    _t2;

import { useMemo, Fragment } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { createGlobalStyle } from 'styled-components';
import { OLAF } from 'HubStyleTokens/colors';
import { TEMPLATE_SECTION_DIVIDER_BORDER_COLOR } from 'HubStyleTokens/theme';
import { Header } from 'marketing-dot-com-nav';
import { MAIN_SECTION_MAX_WIDTH, MAIN_SECTION_PADDING_X } from '../../constants/layout';
const GlobalHeaderStyle = createGlobalStyle(_t || (_t = _`
  .hsg-page-width-normal,
  .hs-page-width-normal {
    max-width: ${0}px !important;
    padding: 0 !important;

    @media (min-width: 768px) {
      padding: 0 ${0}px !important;
    }
  }

  .hsg-nav__group-item.hsg-nav__group-item--cta {
    @media (min-width: 768px) {
      padding-right: 0;
    }
  }

  .hsg-nav__group-item.hsg-nav__group-item--search {
    display: none;
  }

  .hsg-nav__group-item > #hsg-nav__logo > #hsg-nav__logo-mobile {
    display: none;
  }
`), MAIN_SECTION_MAX_WIDTH, MAIN_SECTION_PADDING_X);
const MarketplaceNavStyle = createGlobalStyle(_t2 || (_t2 = _`
  #hsg-nav-2016,
  #hsg-nav-global {
    > div > nav,
    > nav {
      background-color: ${0};
      border-bottom: 1px solid ${0};
    }
  }
`), OLAF, TEMPLATE_SECTION_DIVIDER_BORDER_COLOR);

const MarketingNavHeader = ({
  contentBlob,
  enableConvertFlag,
  lang,
  variation
}) => {
  const HeaderComponent = useMemo(() => {
    if (lang === 'ja') {
      return Header.jp;
    }

    return Header[lang] || Header.en;
  }, [lang]);
  const {
    contentBlob: defaultContentBlob
  } = HeaderComponent;
  const computedContentBlob = useMemo(() => {
    if (!(contentBlob && defaultContentBlob)) {
      return contentBlob;
    }

    return Immutable.fromJS(defaultContentBlob).mergeDeep(contentBlob).toJS();
  }, [contentBlob, defaultContentBlob]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(GlobalHeaderStyle, {}), variation === 'marketplace' && /*#__PURE__*/_jsx(MarketplaceNavStyle, {}), /*#__PURE__*/_jsx(HeaderComponent, {
      contentBlob: computedContentBlob,
      enableConvertFlag: enableConvertFlag,
      isLoggedIn: false,
      variation: variation
    })]
  });
};

MarketingNavHeader.propTypes = {
  contentBlob: PropTypes.object,
  enableConvertFlag: PropTypes.bool,
  lang: PropTypes.string,
  variation: PropTypes.oneOf(['default', 'marketplace'])
};
MarketingNavHeader.defaultProps = {
  lang: 'en',
  variation: 'marketplace'
};
export default MarketingNavHeader;